import { Paper } from '@mantine/core';
import { Route, Switch, useRoute } from 'wouter';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { PERMISSIONS } from '@/models/permissions';
import CommercialProposalEditPage from './CommercialProposalEditPage';
import CommercialProposalListPage from './CommercialProposalListPage';
import CommercialProposalViewPage from './CommercialProposalViewPage';

export default function CommercialProposalsPage() {
  const [isViewRoute] = useRoute('/commercial-proposals/view/:id');

  return (
    <Paper p={isViewRoute ? 0 : 'md'} h={'100%'}>
      <Switch>
        <Route path="/view/:id" component={CommercialProposalViewPage} />
        <Route
          path="/edit/:id"
          component={(props) => (
            <ProtectedRoute
              component={CommercialProposalEditPage}
              permissions={[PERMISSIONS.PROPOSALS_WRITE]}
              {...props}
            />
          )}
        />
        <Route path="/" component={CommercialProposalListPage} />
      </Switch>
    </Paper>
  );
}
